export default __webpack_public_path__ + "static/media/promo-how-far-will-fudge-go_03.9f425eeb.jpg";